import type { ReactNode } from "react";
import Breadcrumbs, { type Crumb } from "@/components/feature/Breadcrumbs";

type PageHeaderProps = {
  eyebrow?: string;
  title: string;
  description?: string;
  crumbs: Crumb[];
  children?: ReactNode;
};

export default function PageHeader({ eyebrow, title, description, crumbs, children }: PageHeaderProps) {
  return (
    <section className="relative w-full overflow-hidden bg-foreground-950 pb-12 pt-28 md:pb-16 md:pt-36">
      <div className="absolute inset-0 bg-gradient-to-br from-foreground-950 via-secondary-900 to-primary-900/80" />
      <div className="absolute -right-16 top-10 h-56 w-56 rounded-full bg-accent-500/15 blur-2xl" />
      <div className="absolute -left-10 bottom-0 h-40 w-40 rounded-full bg-primary-500/20 blur-2xl" />

      <div className="relative z-10 mx-auto max-w-6xl px-4 md:px-8">
        <Breadcrumbs items={crumbs} invert />
        {eyebrow && (
          <p className="mt-6 flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.25em] text-accent-300">
            <span className="inline-block h-px w-8 bg-accent-400" />
            {eyebrow}
          </p>
        )}
        <h1 className="mt-4 max-w-3xl font-heading text-2xl font-bold leading-tight text-background-50 md:text-4xl">
          {title}
        </h1>
        {description && (
          <p className="mt-4 max-w-2xl text-sm leading-relaxed text-background-100 md:text-base">{description}</p>
        )}
        {children}
      </div>
    </section>
  );
}